<template>
    <v-card @click="$emit('click', )">
       <v-card-text>
         <provider-subscription ref="subscriptionForm"></provider-subscription>
       </v-card-text>
    </v-card>
</template>

<script>
    import WMainTitle from '@/components/common/WMainTitle'
    import ProviderStats from '@/components/providers/ProviderStats'
    import ProviderSubscription from '@/components/providers/ProviderSubscription'

    import {debounce} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'

    import {mapState, mapMutations} from 'vuex'

    export default{
        components: {
            WMainTitle,
            ProviderStats,
            ProviderSubscription
        },
        created(){
           this.checkFiltersShowByQuery()
        },
        mounted(){
            var vm = this
            vm.checkFiltersShowByQuery()
            vm.fillFiltersFromQuery()
            vm.$nextTick(function(){
                //vm.debounceGetProviders()
            })
        },
        updated(){
            //this.checkFiltersShowByQuery()
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            showProviderAccount(id){
                this.$refs.subscriptionForm.showDialog(id)
            },
            setFiltersWereChanged(){
                var vm = this
                if(vm.filters){
                    vm.filtersWereChanged = true
                }

            },

            checkFiltersShowByQuery(){
                var vm = this
                if(vm.$route.query.show_filters && vm.$route.query.show_filters == 'true'){
                    vm.showFilters()
                }
            },
            clearAllFilters(){
                var vm = this
                this.$refs.specialtySelector.clear()
                vm.reputationFilter = [1, 5]
            },
            debounceApplyFilter: debounce(function(showDrawer = false){
                this.applyFilters(showDrawer)
            }, 500),
            debounceGetProviders: debounce(function(){
                this.getProviders()
            }, 500),
            applyFilters(showDrawer = false){

                var vm = this

                vm.items = []
                vm.moreItemsLink = null

                var filters = {
                    specialty: vm.specialtyFilter.map(s => s.id).join(','),
                    commune: vm.communeFilter.map(s => s.id).join(','),
                    reputation: vm.reputationFilter.join(','),
                    name: vm.search,
                    show_filters: showDrawer,
                    only: vm.typeFilter
                }

                vm.filtersWereChanged = false

                vm.$router.push({
                    query: filters
                })

                vm.$nextTick(function(){
                    vm.getProviders()
                })

            },
            onScroll(evt){

                return

                var vm = this

                const el = evt.target.getElementsByTagName('html')[0]
                const scrollVal = el.scrollTop
                const height = el.offsetHeight

                if(scrollVal >= (height - 1500) && vm.moreItemsLink){
                    vm.getMoreSpecialists()
                }

                if (scrollVal >= 196) {
                    this.stickyFilters = true
                    return
                }

                this.stickyFilters = false

            },
            showFilters(){
                this.filters = true
            },
            clearSearch(){
                this.search = ''
                this.applyFilters()
            },
            async getProviders(url = ''){
                var vm = this
                vm.noResults = false

               var filters = {
                   service_items: vm.specialtyFilter.map(specialty=>specialty.id).join(','),
                   with_ratings: 1,
                   with_service_item: 1,
                   name: vm.search,
                   reputation: vm.reputationFilter.join(','),
                   communes: vm.communeFilter.map(commune => commune.id).join(','),
                   only: vm.typeFilter
               }
                vm.loading = true
                const response = url ? await ApiUtils.makeGet(url) :
                        await ApiUtils.makeGet('public/providers', filters)
                vm.loading = false

                if (!response.ok) {
                    vm.showSnackBar('Error intentando cargar proveedores')
                    return
                }

                const json = await response.json()
                vm.items = vm.items.concat(json.result.providers.data)
                vm.moreItemsLink = json.result.providers.next_page_url

            },
            getMoreSpecialists(){
                var vm = this
                if(!vm.moreItemsLink) return
                vm.getProviders(vm.moreItemsLink)

            },
            onSpecialtyChange(specialty){
                this.specialtyFilter = specialty;
            },
            onCommuneChange(commune){
                this.communeFilter = commune
            }
        },
        data(){
            return {

                filtersWereChanged: false,

                search: '',
                filters: false,
                loading: true,

                noResults: false,

                communeChip: false,
                specialtyChip: false,
                reputationChip: false,

                communeFilter: [],
                specialtyFilter: [],
                reputationFilter: [1, 5],
                typeFilter: '',

                stickyFilters: false,

                items: [],
                moreItemsLink: null,
                breadcrumbs: [
                    {
                        text: 'Inicio',
                        disabled: false,
                        to: '/'
                    },
                    {
                        text: 'Servicios',
                        disabled: true,
                        href: ''
                    },
                ]
            }
        },
        watch: {
            filters(val){
              if(!val && this.filtersWereChanged){
                  this.applyFilters()
              }
            },
            search(val){
                if(this.search && this.search.length < 3) return
                //this.debounceApplyFilter()
            },
            typeFilter(val){
                var vm = this
                this.debounceApplyFilter()
            },
            communeFilter(val){
                var vm = this
                vm.communeChip = val.length > 0
                vm.setFiltersWereChanged()
            },
            specialtyFilter(val){
                var vm = this
                vm.specialtyChip = val.length > 0
                vm.setFiltersWereChanged()
            },
            reputationFilter(val){
                var vm = this
                vm.reputationChip = !(val[0] === 1 && val[1] === 5)
                vm.setFiltersWereChanged()
            },


            communeChip(val){
                if (!val) {
                    this.$refs.communeSelector.clear()
                    this.debounceApplyFilter()
                }
            },
            specialtyChip(val){
                if (!val) {
                    this.$refs.specialtySelector.clear()
                    this.debounceApplyFilter()
                }
            },
            reputationChip(val){
                if (!val) {
                    this.reputationFilter = [1, 5]
                    this.debounceApplyFilter()
                }
            },
            items(value){
                var vm = this
                if(!value || !value.length){
                    vm.noResults = true
                }else{
                    vm.noResults = false
                }
            }

        },
        computed: {
            ...mapState([
                'currentUser',
                'userDataComplete',
                'institutionDataComplete',
                'regions'
            ]),
            hasFilters(){
                var vm = this
                return vm.communeFilter.length > 0 ||
                        vm.specialtyFilter.length > 0 ||
                        vm.reputationFilter[0] !== 1 ||
                        vm.reputationFilter[1] !== 5
            }
        }
    }
</script>

<style scoped>

    .account-btn{
        position: absolute;
        left: 60px;
        top: 80px;
        width: 35px;
        height: 35px;
        font-size: 14px;
        z-index: 10;
    }

    .flex-center {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    >>>.sticky-filters {
        position: fixed !important;
        top: 4px;
    }

    .specialist-wrapper {
        position: relative;
        background-color: rgba(255, 255, 255, .7);
        transition: .1s all
    }

    .specialist-wrapper:hover {
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.3);
        transform: scale(1.01)
    }

    .bg-blur {
        background-size: cover;
        background-attachment: fixed;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -2;
        opacity: .7;
    }

    .fixed-bg-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: .95;
        z-index: -1;
        pointer-events: none;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#7db9e8+0,1e5799+36 */
        background: rgb(125, 185, 232); /* Old browsers */
        background: -moz-linear-gradient(top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#7db9e8', endColorstr='#1e5799', GradientType=0); /* IE6-9 */
    }


</style>